module.exports = __webpack_public_path__ + "media/grass-35-default-compression.f7fcbdb3.mp4";